<div class="eventq-popover-search">
  <input
    class="eventq-popover-search__input"
    type="search"
    [placeholder]="placeholder()"
    [value]="value()"
    (input)="onInput($event)"
  />
  <mat-icon class="eventq-popover-search__icon" aria-hidden="true">search</mat-icon>
</div>
